import React from 'react';
import { AbsoluteFill } from 'remotion';
import { ThemeSystemConfig } from '../../clipCreator/remotion/Components/Theme/Theme';
import { AspectRatio } from '../AspectRatio';
import { TimelineDefaults } from '../TimelineDefaults';
import { BackgroundItem } from '../types';
import { LayerContainer } from './types';

export class BackgroundLayerContainer implements LayerContainer {
    items: BackgroundItem[];

    constructor(items: BackgroundItem[]) {
        this.items = items;
    }

    render(fps: number, theme: ThemeSystemConfig, aspectRatio: AspectRatio, defaults: TimelineDefaults, videoConfig?: { width: number; height: number }): React.ReactNode {
        return (
            <AbsoluteFill>
                {this.items.map(item => (
                    <React.Fragment key={item.id}>
                        {item.render(fps, theme, aspectRatio, defaults, videoConfig)}
                    </React.Fragment>
                ))}
            </AbsoluteFill>
        );
    }
} 